import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

type VariantType = 'light' | 'dark';

interface TogglePropsType {
  isDisabled?: boolean;
  variant: VariantType;
}

export const ToggleWrapper = withConfig(theme => styled('div', { label: 'ToggleWrapper' })<TogglePropsType>`
    display: flex;
    align-items: center;
    flex-flow: row nowrap;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontSize.regular};
    line-height: 1.3334;
    ${({ isDisabled }): string => isDisabled === true ? 'pointer-events: none; opacity: 0.4' : ''};
`);

export const SliderWrapper = styled('label', { label: 'SliderWrapper' })`
    position: relative;
    width: 44px;
    height: 24px;
`;

type InputType = Pick<TogglePropsType, 'variant'>;

export const Input = withConfig(theme => styled('input', { label: 'Input' })<InputType>`
    opacity: 0;
    width: 0;
    height: 0;
    margin: 0;

    &:checked + span {
        background-color: ${({ variant }): string => variant === 'light' ? theme.star.toggle.light.bgColorTertiary : theme.star.toggle.dark.bgColorTertiary};
    }

    &:checked + span::before {
        transform: translateX(20px);
    }
`);

type SliderType = Pick<TogglePropsType, 'variant'>;

export const Slider = withConfig(theme => styled('span', { label: 'Slider' })<SliderType>`
    position: absolute;
    cursor: pointer;
    inset: 0;
    background-color: ${({ variant }): string => variant === 'light' ? theme.star.toggle.light.bgColorSecondary : theme.star.toggle.dark.bgColorSecondary};
    border-radius: 24px;
    transition: background-color .2s ease;

    &::before {
        position: absolute;
        content: '';
        height: 20px;
        width: 20px;
        inset: 2px auto auto 2px;
        background-color: ${({ variant }): string => variant === 'light' ? theme.star.toggle.light.bgColor : theme.star.toggle.dark.bgColor};
        transition: transform .2s ease;
        border-radius: 50%;
        box-shadow: 0 1px 3px 0 ${theme.star.toggle.opacity};
    }
`);
